import { Injectable } from '@angular/core';
import { WrapperHttpService } from '../../../../services/wrapper-http-service';
import { TransportManagementEndpoint } from '../constants/transport-management-endpoint';
import { API_URL } from '../../../../../services/config';
import { TransportManagementSearchCriteria } from '../models/transport-management.model';
import { Observable } from 'rxjs';
import { ListViewMode } from '../../constants/list-view-mode.constant';
import { convertDateRangesToWallClockUTC } from '../../../../../common';

@Injectable({ providedIn: 'root' })
export class TransportManagementExportService {
  private readonly url = `${API_URL}${TransportManagementEndpoint.Exports}${TransportManagementEndpoint.Base}`;
  constructor(private http: WrapperHttpService) {}

  startExportToFile(body: {
    reportName: string;
    viewMode: ListViewMode;
    filter: Partial<TransportManagementSearchCriteria>;
  }): Observable<void> {
    return this.http
      .withLoading()
      .post<void>(this.url, { ...body, filter: convertDateRangesToWallClockUTC(body.filter) });
  }
}
